import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './header'
import Siderbar from './Siderbar'
const Mainmenu = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <div className="c-dashboard">
      <Siderbar isOpen={isOpen}/>
      <div className={`c-dashboard__transparent ${isOpen && `c-dashboard__transparent--active`}`} onClick={() => setIsOpen(false)}/>
      <div className="c-dashboard__container-content">
        <Header setIsOpen={setIsOpen}/>
        <main className="c-dashboard__content">
          <Outlet/>
        </main>
      </div>
    </div>
  )
}

export default Mainmenu